import React, { Suspense } from "react";
import NewLayout from "./NewLayout";
import Loader from "../components/Spinner/Loader";
import { theme } from "@ovou-inc/ovou-ui";
import { SuspenseLayoutProps } from "./types";

const SuspenseLayout: React.FC<SuspenseLayoutProps> = ({
  children,
  backgroundColor = theme.palette.ui.greys.grey5,
}) => {
  return (
    <NewLayout backgroundColor={backgroundColor}>
      <Suspense fallback={<Loader />}>{children}</Suspense>
    </NewLayout>
  );
};

export default SuspenseLayout;
